import Row from "@Containers/components/Row";
import React from "react";
import SeatClassType from "@Route/types/travelInfo/SeatClass.type";
import Column from "@Containers/components/Column";
import ImageSlider from "@Features/slider/features/imageSlider/components/ImageSlider";
import SeatClassImage from "@Route/components/SeatClass/SeatClassImage";
import {isNotEmpty} from "@Array/isNotEmpty";
import AmenityContainer from "@Route/components/SeatClass/AmenityContainer";

type SeatClassProps = {
    seatClass: SeatClassType,
    displayImages?: boolean,
    displayDescription?: boolean,
    children?: React.ReactNode
    classNameDecoration?: React.ReactNode
}

function SeatClass({seatClass, displayImages, displayDescription, children, classNameDecoration}: SeatClassProps) {
    return (
        <>
            <Column>
                <Row justify center>
                    <div>
                        <h4>
                            {seatClass.className}
                        </h4>
                        {classNameDecoration}
                    </div>
                    {children}
                </Row>
                <span>{seatClass.description}</span>
                <Column className="gb--route-amenities_icons">
                    {seatClass.amenities.map((amenity) => (
                        <AmenityContainer
                            key={amenity.id}
                            displayDescription={displayDescription}
                            amenity={amenity}
                        />
                    ))}
                </Column>
            </Column>
            {displayImages && isNotEmpty(seatClass?.images) && (
                <Row className="gb--route-seat_classes">
                    <ImageSlider
                        ImageComponent={SeatClassImage}
                        images={seatClass.images}
                        prepareImage={(image) => ({image, className: "seat-class-image__small"})}
                        prepareOpenImage={(image) => ({image, className: "seat-class-image__opened"})}
                    />
                </Row>
            )}
        </>
    );
}

export default SeatClass;